<template lang="pug">
  transition(name="page")
    .theater-overlay(v-if="isActive")
      .theater-overlay-bg(@click="onLeave")
      .theater-overlay-thumb
        img(:src="image" :alt="title")
      .theater-overlay-body
        h3.theater-overlay-title {{ title }}
      .theater-overlay-icons
        ShareButton(provider="facebook" :text="title" :image="image" :link="$route.path")
        ShareButton(provider="twitter" :text="title" :image="image" :link="$route.path")
        ShareButton(provider="pinterest" :text="title" :image="image" :link="$route.path")
        slot(name="buttons")
</template>

<script>
import ShareButton from '~/components/ShareButton';

export default {
  name: 'TheaterOverlay',
  components: {
    ShareButton
  },
  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    image: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  methods: {
    onLeave() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="stylus">
.theater
  &-overlay
    position: fixed
    top: 0
    right: 0
    bottom: 0
    left: 0
    background: alpha($clBg, 0.9)
    z-index: 10
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    text-align: center

    &-title
      margin: 10px 0
      color: $clBlack
      max-width: 700px

    &-bg
      position: absolute
      top: 0
      right: 0
      left: 0
      bottom: 0
      z-index: -1
      cursor: zoom-out

    &-thumb
      img
        max-height: 80vh
        width: auto
        max-width: 100%

    &-icons
      color: $clBlack
      display: flex
      margin-left: -5px
      margin-right: -5px

      >*
        margin: 0 5px

      .icon
        color: $clBlack
        fill: $clBlack

        &:hover
          fill: $clPrimary

    &-like
      display: flex
      align-items: center
      cursor: pointer

      &.is-active
        color: $clPrimary

        .icon
          fill: $clPrimary

      span
        margin: 0 5px
        display: inline-block
        font-weight: $fontWeight-bold
        line-height: 1

.is-dark
  .theater-overlay
    background: alpha(#000, 0.9)

    &-title
      color: $clWhite

    &-icons
      color: $clWhite

      >*
        margin: 0 5px

      .icon
        color: $clWhite
        fill: $clWhite

        &:hover
          fill: $clPrimary
</style>
